import React, { Component } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Button,
  Input,
  InputGroupAddon,
  InputGroup,
} from "reactstrap";
import { toast } from "react-toastify";
import Pagination from "../components/common/pagination";
import { getMachineByName, getInferenceMachines } from "../services/inferenceMachineService";

import MachinesTable from "../components/MachinesTable";
import userHasRole from "../components/shared/utils/authUtils";
import { editorRole, qualityRole } from "../components/shared/constants";
import DisplayWhen from "../components/common/base/DisplayWhen";

class MachinesView extends Component {
  state = {
    machines: [],
    currentPage: 1,
    count: 0,
    pageSize: 1,
    highLight: false,
    query: "",
  };

  timer = null;

  async componentDidMount() {
    await this.fetchMachines();
  }

  async componentDidUpdate(prevProps, prevState) {
    const { query, currentPage } = this.state;
    if (prevState.query !== query) {
      if (query === "" || query.length > 2) this.timer = setTimeout(() => this.fetchMachines(), 500);
    } else if (prevState.currentPage !== currentPage) {
      await this.fetchMachines();
    }
  }

  componentWillUnmount() {
    if (this.timer) clearTimeout(this.timer);
  }

  fetchMachines = async () => {
    const { currentPage, query } = this.state;
    try {
      const { data: pagedMachines } = await getInferenceMachines(currentPage, query);
      const machines = pagedMachines.results;
      const { count } = pagedMachines;

      let pageSize = 1;
      if (pagedMachines.next) {
        pageSize = machines.length;
      } else {
        pageSize = Math.ceil(count / currentPage);
      }

      this.setState({ machines, count, pageSize });
    } catch (ex) {
      console.log(ex);
      toast.error("Failed to connect, please log in");
    }
  };

  handleFindMachine = async () => {
    const { query, machines } = this.state;
    const hostname = query;
    try {
      const { data: machine } = await getMachineByName(hostname);
      const originalMachines = machines;
      let filteredMachines = originalMachines.filter((originalMachine) => originalMachine.id !== machine.id);
      filteredMachines = [machine, ...filteredMachines];
      const highLight = true;
      this.setState({ machines: filteredMachines, highLight });
    } catch (ex) {
      if (ex.response && ex.response.status === 404) {
        if (ex.response.data && ex.response.data.detail) {
          toast.error(ex.response.data.detail);
        } else {
          toast.error("Machine not found");
        }
      } else if (ex.response && ex.response.status === 400) {
        Object.keys(ex.response.data).forEach(function (key) {
          const message = `${key}: ${ex.response.data[key][0]}`;
          toast.error(message);
        });
      } else if (ex.response && ex.response.status === 401) {
        toast.error(ex.response.data.error);
      } else {
        toast.error("Unhandled error");
      }
    }
  };
  handleChange = (value) => {
    clearTimeout(this.timer);
    this.setState({ query: value, currentPage: 1 });
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  render() {
    const { count, pageSize, currentPage, machines, highLight } = this.state;
    return (
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4">Machines</CardTitle>
                <Row>
                  <Col md="4">
                    <InputGroup>
                      <Input
                        name="find_machine"
                        id="find_machine"
                        placeholder="Machine name"
                        onChange={(e) => this.handleChange(e.currentTarget.value)}
                      />
                      <InputGroupAddon addonType="append">
                        <Button className="input-group-button" onClick={this.handleFindMachine}>
                          Find machine
                        </Button>
                      </InputGroupAddon>
                    </InputGroup>
                  </Col>

                  <DisplayWhen condition={userHasRole(editorRole) && !userHasRole(qualityRole)}>
                    <Col md="4">
                      <Button>Add new machine</Button>
                    </Col>
                  </DisplayWhen>
                </Row>
              </CardHeader>
              <CardBody>
                <MachinesTable machines={machines} highLight={highLight} />
                <Pagination
                  itemsCount={count}
                  pageSize={pageSize}
                  currentPage={currentPage}
                  onPageChange={this.handlePageChange}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default MachinesView;
